import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class UnsupportedBrowserPopup extends Popup {
    constructor(props) {
        super(props);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');

        let className = 'popup popup-browser-check browsercheck ' + this.state.visibility;

        let generalPopup = (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p dangerouslySetInnerHTML={{__html: lang.supported_browsers}}/>
                <br/>
                <button className="popup-button" onClick={() => this.close()}>OK</button>
             </div>
        );

        let firefoxESRPopup = (
            <div className={className + ' firefox-esr'} ref={(ref) => this._ref = ref}>
                <p dangerouslySetInnerHTML={{__html: lang.firefox_esr}}/>
                <br/>
                <button className="popup-button" onClick={() => this.close()}>OK</button>
             </div>
        );

        return (this.props.firefoxESR ? firefoxESRPopup : generalPopup);
    }
}

UnsupportedBrowserPopup.generateKey = function() { return 'popup-browser-check' };
UnsupportedBrowserPopup.mount = function(props, onMount) { return Popup.mount(UnsupportedBrowserPopup, props, onMount) };
UnsupportedBrowserPopup.open = function(props) {
    let id = UnsupportedBrowserPopup.generateKey(props);

    if (!Popup.popups[id]) {
        UnsupportedBrowserPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};

export default UnsupportedBrowserPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UnsupportedBrowserPopup/index.js